import { render, staticRenderFns } from "./ProgramTile.vue?vue&type=template&id=4490cd6c&"
import script from "./ProgramTile.vue?vue&type=script&lang=js&"
export * from "./ProgramTile.vue?vue&type=script&lang=js&"
import style0 from "./ProgramTile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProgramTile.vue"
export default component.exports